<template>
  <div class="p-page-wrapper p-hours">
    <div class="p-toolbar">
      <div class="p-toolbar-item p-search">
        <p-search-input
          v-model="search"
          :items="searchSuggestions"
        ></p-search-input>
      </div>
      <div class="p-toolbar-item">
        <div class="p-month-year-picker">
          <v-menu
            v-model="datepickerMenu"
            :close-on-content-click="false"
            max-width="290px"
            min-width="auto"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <div
                v-on="on"
                class="p-month-year-picker-display"
              >
                <v-icon>mdi-calendar-outline</v-icon>
                {{ datepickerDisplayValue }}
              </div>
            </template>
            <v-date-picker
              v-model="datepickerValue"
              type="month"
              no-title
              scrollable
              @change="onDatepickerChange"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
    </div>

    <v-row>
      <v-col>
        <div
          v-for="contactReport of reportByContactsFiltered"
          :key="contactReport.contact.id"
        >
          <div class="p-hours__table">
            <div class="p-hours__table-row p-header">
              <div class="p-hours__table-cell p-name">
                <p-contact-item
                  :contact="contactReport.contact"
                  font-bold
                ></p-contact-item>
              </div>
              <div class="p-hours__table-cell p-summary">
                <div class="p-w-100">
                  <div>{{ $t('hours.table.summary') }}</div>
                  <span>{{ $t('hours.table.workShort') }}</span>
                  <span>{{ $t('hours.table.eveningShort') }}</span>
                  <span>{{ $t('hours.table.holidayShort') }}</span>
                </div>
              </div>
              <div
                v-for="col of tableDateCols"
                :key="col.value"
                class="p-hours__table-cell p-date"
              >
                <div class="p-w-100">
                  <div>{{ col.text }}</div>
                  <span>{{ $t('hours.table.workShort') }}</span>
                  <span>{{ $t('hours.table.eveningShort') }}</span>
                </div>
              </div>
            </div>

            <div
              v-for="item of contactReport.reportItems"
              :key="item.id"
              :class="`p-hours__table-row p-level-${item.level}`"
            >
              <div class="p-hours__table-cell p-name">
                {{ item.name }}
              </div>
              <div
                :set="h = item.hours.summary"
                class="p-hours__table-cell p-summary"
              >
                <template v-if="h">
                  <span>{{ h.hoursPlan }}</span>
                  <span>0</span>
                  <span>0</span>
                  <span :class="{ 'pGreen--text': h.hoursWork <= h.hoursPlan, 'pRed--text': h.hoursWork > h.hoursPlan }">{{ h.hoursWork ? h.hoursWork : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursEvening > 0 }">{{ h.hoursEvening ? h.hoursEvening : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursHoliday > 0 }">{{ h.hoursHoliday ? h.hoursHoliday : '' }}</span>
                </template>
              </div>
              <div
                v-for="col of tableDateCols"
                :key="col.value"
                :set="h = item.hours[col.value]"
                class="p-hours__table-cell p-date"
              >
                <template v-if="h">
                  <span>{{ h.hoursPlan }}</span>
                  <span>0</span>
                  <span :class="{ 'pGreen--text': h.hoursWork <= h.hoursPlan, 'pRed--text': h.hoursWork > h.hoursPlan }">{{ h.hoursWork ? h.hoursWork : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursEvening > 0 }">{{ h.hoursEvening ? h.hoursEvening : '' }}</span>
                </template>
              </div>
            </div>

            <div class="p-hours__table-row p-footer">
              <div class="p-hours__table-cell p-name">
                <div>{{ $t('hours.table.summary') }}</div>
                <div>
                  <span>{{ $t('hours.table.planned') }}</span>
                  <span>{{ $t('hours.table.actual') }}</span>
                </div>
              </div>
              <div
                :set="h = contactReport.hours.summary"
                class="p-hours__table-cell p-summary"
              >
                <template v-if="h">
                  <span>{{ h.hoursPlan }}</span>
                  <span>0</span>
                  <span>0</span>
                  <span :class="{ 'pGreen--text': h.hoursWork <= h.hoursPlan, 'pRed--text': h.hoursWork > h.hoursPlan }">{{ h.hoursWork ? h.hoursWork : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursEvening > 0 }">{{ h.hoursEvening ? h.hoursEvening : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursHoliday > 0 }">{{ h.hoursHoliday ? h.hoursHoliday : '' }}</span>
                </template>
              </div>
              <div
                v-for="col of tableDateCols"
                :key="col.value"
                :set="h = contactReport.hours[col.value]"
                class="p-hours__table-cell p-date"
              >
                <template v-if="h">
                  <span>{{ h.hoursPlan }}</span>
                  <span>0</span>
                  <span :class="{ 'pGreen--text': h.hoursWork <= h.hoursPlan, 'pRed--text': h.hoursWork > h.hoursPlan }">{{ h.hoursWork ? h.hoursWork : '' }}</span>
                  <span :class="{ 'pRed--text': h.hoursEvening > 0 }">{{ h.hoursEvening ? h.hoursEvening : '' }}</span>
                </template>
              </div>
            </div>
          </div>

          <div class="p-hours__status-wrapper">
            <div
              v-if="contactReport.statusId === null"
            >
              {{ $t('hours.status.notSubmitted') }}
            </div>
            <v-btn
              v-else-if="contactReport.statusId === worklogReportStatus.delivered"
              class="p-btn-rounded"
              color="primary"
              large
              rounded
              dark
              @click="acceptHours(contactReport.contact.id, monthYear.year, monthYear.month)"
            >
              {{ $t('hours.accept') }}
            </v-btn>
            <div
              v-if="contactReport.statusId === worklogReportStatus.accepted"
            >
              <v-icon color="pGreen">mdi-check-circle-outline</v-icon>
              <div class="pGreen--text ml-1 d-inline-block">{{ $t('hours.status.accepted') }}</div>
              <v-btn
                color="primary"
                class="ml-3"
                text
                dark
                @click="unacceptHours(contactReport.contact.id, monthYear.year, monthYear.month)"
              >
                {{ $t('hours.unaccept') }}
              </v-btn>
            </div>
          </div>
        </div>
        <p-no-data
          v-if="worklogReportLoaded(monthYear.year, monthYear.month) && !worklogReport(monthYear.year, monthYear.month).length"
          :text="$t('hours.noData')"
          img="worklog.png"
          class="p-no-data-mt"
          hide-btn
        ></p-no-data>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import { worklogReportStatus } from '@/constants'

import moment from 'moment'

import PContactItem from '@/components/PContactItem'
import PSearchInput from '@/components/PSearchInput'
import PNoData from '@/components/PNoData'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'

export default {
  components: {
    PContactItem,
    PSearchInput,
    PNoData
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      search: '',
      datepickerMenu: false,
      datepickerFormat: 'YYYY-MM',
      datepickerDisplayFormat: 'MMMM YYYY',
      datepickerValue: '',
      worklogDatePropFormat: 'YYYY-MM-DD',
      worklogReportStatus
    }
  },


  computed: {
    ...mapGetters('project', ['shortProjectById']),
    ...mapGetters('contact', ['shortContactById', 'shortContacts']),
    ...mapGetters('worklogReport', ['worklogReport', 'worklogReportLoaded']),

    tableDateCols () {
      const date = moment(this.datepickerValue, this.datepickerFormat)
      const headers = []

      for (let i = 1; i <= date.daysInMonth(); i++) {
        headers.push({
          text: i,
          value: date.date(i).format(this.worklogDatePropFormat)
        })
      }

      return headers
    },

    searchSuggestions () {
      return this.reportByContacts.map(reportItem => {
        return reportItem.name
      })
    },

    datepickerDisplayValue () {
      return this.datepickerValue ? moment(this.datepickerValue, this.datepickerFormat).format(this.datepickerDisplayFormat) : ''
    },

    monthYear () {
      if (!this.datepickerValue) return {}

      const date = moment(this.datepickerValue, this.datepickerFormat)
      return {
        year: date.year(),
        month: date.month() + 1
      }
    },

    reportByContacts () {
      const report = this.worklogReport(this.monthYear.year, this.monthYear.month)
      let reportByContacts = []

      for (const contactReport of report) {
        const reportByLevels = this.rearrangeWorklogReportByLevels(contactReport.dates)
        const contact = this.shortContactById(contactReport.contactId) || {}

        reportByContacts.push({
          contact,
          name: contact.displayNameWithCompany,
          statusId: contactReport.statusId,
          reportItems: this.toSortedArray(reportByLevels.items, []),
          hours: reportByLevels.hours
        })
      }

      reportByContacts = reportByContacts.sort((x, y) => x.name.localeCompare(y.name))

      return reportByContacts
    },

    reportByContactsFiltered () {
      if (!this.search) return this.reportByContacts

      const search = this.search.toUpperCase()

      return this.reportByContacts.filter(x => x.name.toUpperCase().indexOf(search) >= 0)
    }
  },


  methods: {
    ...mapActions('worklogReport', ['loadWorklogReport', 'acceptWorklogReport', 'unacceptWorklogReport']),
    ...mapActions('contact', ['loadShortContacts']),
    ...mapActions('project', ['loadAllProjects']),

    rearrangeWorklogReportByLevels (reportItems) {
      const levelKeys = ['projectId', 'eventId']
      const result = { hours: {}, items: {} }

      for (const reportItem of reportItems) {
        const { date, hoursPlan, hoursWork, hoursEvening, hoursHoliday } = reportItem
        const hours = { hoursPlan, hoursWork, hoursEvening, hoursHoliday }
        const dateProp = moment(date).format(this.worklogDatePropFormat)

        result.hours.summary = result.hours.summary ? this.summarizeHours(result.hours.summary, hours) : hours
        result.hours[dateProp] = result.hours[dateProp] ? this.summarizeHours(result.hours[dateProp], hours) : hours

        levelKeys.reduce(({ items, parent }, key, index) => {
          if (parent && !reportItem[parent.key]) {
            return { items, parent }
          }

          const itemId = reportItem[key] || '-'

          if (!items[itemId]) {
            items[itemId] = {
              id: parent?.id + itemId,
              name: this.getReportItemNameByKey(key, reportItem),
              level: index,
              key,
              hours: {},
              items: {}
            }
            items[itemId].hours.summary = hours
            items[itemId].hours[dateProp] = hours
          } else {
            items[itemId].hours.summary = this.summarizeHours(items[itemId].hours.summary, hours)
            items[itemId].hours[dateProp] = items[itemId].hours[dateProp] ? this.summarizeHours(items[itemId].hours[dateProp], hours) : hours
          }

          return { items: items[itemId].items, parent: items[itemId] }
        }, { items: result.items, parent: null })
      }

      return result
    },

    toSortedArray (items, result) {
      const array = Object.values(items).sort((x, y) => {
        return x.name.localeCompare(y.name)
      })

      for (const levelItem of array) {
        result.push(levelItem)
        this.toSortedArray(levelItem.items, result)
      }

      return result
    },

    summarizeHours (hours1, hours2) {
      const hours = {}
      for (const prop in hours1) {
        hours[prop] = Math.round((hours1[prop] + hours2[prop]) * 100) / 100
      }
      return hours
    },

    getReportItemNameByKey (key, reportItem) {
      let name

      switch (key) {
        case 'projectId': {
          if (reportItem.projectId) {
            name = this.shortProjectById(reportItem.projectId)?.title
          }
          break
        }
        case 'eventId': {
          if (reportItem.eventName) {
            name = reportItem.eventName
          }
        }
      }

      return name || '-'
    },

    async onDatepickerChange () {
      try {
        this.datepickerMenu = false
        this.startPageLoading()
        await this.loadWorklogReport(this.monthYear)
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      } finally {
        this.stopPageLoading()
      }
    },

    async acceptHours (contactId, year, month) {
      try {
        this.showSnackbarProcessing()
        await this.acceptWorklogReport({ contactId, year, month })
        this.showSnackbarSuccess()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    async unacceptHours (contactId, year, month) {
      try {
        this.showSnackbarProcessing()
        await this.unacceptWorklogReport({ contactId, year, month })
        this.showSnackbarSuccess()
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  },


  async created () {
    try {
      this.setPageTitle(this.$t('nav.hours'))
      this.startPageLoading()

      await Promise.all([
        this.loadShortContacts(),
        this.loadAllProjects()
      ])

      const today = moment()
      this.datepickerValue = today.format(this.datepickerFormat)
      await this.loadWorklogReport(this.monthYear)
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
